import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { MapsAPILoader, MouseEvent } from '@agm/core';
import {CrudService} from '../services/crud.service'
import { AlertsSectionComponent } from '../sections/alerts-section/alerts-section.component';
import {Router} from '@angular/router';
import { google } from 'google-maps';

@Component({
  selector: 'app-rtx',
  templateUrl: './rtx.component.html',
  styleUrls: ['./rtx.component.scss']
})
export class RtxComponent implements OnInit {
  event = {
    a_lugar: "",
    desc: "",
    estado: "0",
    fecha: "",
    imgp: "",
    imgs: [],
    l_lugar: "",
    linkincripcion: "",
    linkpagina: "",
    linkvideo: "",
    nombre: "",
    pais: "",
    rsFace: "",
    rsInst: "",
    rsTwit: "",
    t_pos: "",
    t_tipo: "",
  };
  infoMessage: any;
  isUploading: boolean = false;
  file: File;
  imgs = [];
  imageUrl: string | ArrayBuffer = "./assets/img/screen/cover.png";
  fileName: string = "No file selected";

  cnt = 0;

  // autocomplete
  title: string = 'AGM project';
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  private geoCoder;

  @ViewChild('search')
  public searchElementRef: ElementRef;
    @ViewChild('country')
  public countryElementRef: ElementRef;
  constructor(private mapsAPILoader: MapsAPILoader,private CrudService : CrudService,private Router : Router,
    private ngZone: NgZone) { }

  ngOnInit(): void {
    for (let i = 0; i < 5; i++) {
      this.imgs[i] = this.imageUrl;
    }
    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;

      let placeAutocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      let countryAutocomplete = new google.maps.places.Autocomplete(this.countryElementRef.nativeElement); 
      placeAutocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = placeAutocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
      countryAutocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = countryAutocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });
  }

  onChange(file: File) {

    if (file) {
      this.fileName = file.name;
      this.file = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = event => {
        this.imageUrl = reader.result;
        this.imgs[this.cnt] = this.imageUrl;
        this.cnt++;
      };

    }
  }
  //push Event to firebase

  pushEvent(){
    this.event.imgs = this.imgs;
    this.CrudService.pushEvent(this.event);
    this.Router.navigate(['landing']);
     console.log(';event' , this.event);

  }

  // // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getAddress(this.latitude, this.longitude);
      });
    }
  }


  markerDragEnd($event: MouseEvent) {
    console.log($event);
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.getAddress(this.latitude, this.longitude);
  }

  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      console.log(results);
      console.log(status);
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 12;
          this.address = results[0].formatted_address;
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }

    });
  }
}
